import { createBrowserRouter, Outlet } from 'react-router-dom';
import LoginPage from './LoginPage';
import LandingPage from './LandingPage';
import AdminLayout from './admin/AdminLayout';
import AdminHomePage from './admin/AdminHomePage';
import AdminReportsPage from './admin/ReportsPage';
import IntegrationsPage from './admin/IntegrationsPage';
import CompaniesPage from './admin/CompaniesPage';
import CompanyDetailPage from './admin/CompanyDetailPage';
import AgreementsPage from './admin/AgreementsPage';
import UsersPage from './admin/UsersPage';
import KnowledgebasePage from './admin/KnowledgebasePage';
import ArticleEditorPage from './admin/ArticleEditorPage';
import AuditLogPage from './admin/AuditLogPage';
import ImpersonationPage from './admin/ImpersonationPage';
import TicketsPage from './admin/TicketsPage';
import TicketDetailPage from './admin/TicketDetailPage';
import PortalLayout from './portal/PortalLayout';
import DashboardPage from './portal/DashboardPage';
import ReportsPage from './portal/ReportsPage';
import NewTicketPage from './portal/NewTicketPage';
import MyTicketsPage from './portal/MyTicketsPage';
import PortalTicketDetailPage from './portal/PortalTicketDetailPage';
import ProfilePage from './ProfilePage';
import ChangelogPage from './ChangelogPage';
import WorkflowsPage from './admin/WorkflowsPage';
import { RequireAuth } from '@/auth/RequireAuth';
import ImpersonationBanner from './admin/ImpersonationBanner';

function RootLayout() {
  return (
    <>
      <ImpersonationBanner />
      <Outlet />
    </>
  );
}

export const router = createBrowserRouter(
  [
    {
      element: <RootLayout />,
      children: [
        { path: '/login', element: <LoginPage /> },
        {
          path: '/',
          element: (
            <RequireAuth>
              <LandingPage />
            </RequireAuth>
          ),
        },
        {
          // Admin shell: every /admin/* route shares AdminLayout + RequireAuth.
          // Plans 02-09..02-13 extend this children array; they do not touch the
          // RequireAuth wrapper or the layout element.
          path: '/admin',
          element: (
            <RequireAuth>
              <AdminLayout />
            </RequireAuth>
          ),
          children: [
            { index: true, element: <AdminHomePage /> },
            { path: 'companies', element: <CompaniesPage /> },
            { path: 'companies/:id', element: <CompanyDetailPage /> },
            { path: 'tickets', element: <TicketsPage /> },
            { path: 'tickets/:id', element: <TicketDetailPage /> },
            { path: 'agreements', element: <AgreementsPage /> },
            { path: 'users', element: <UsersPage /> },
            { path: 'knowledgebase', element: <KnowledgebasePage /> },
            { path: 'workflows', element: <WorkflowsPage /> },
            { path: 'knowledgebase/new', element: <ArticleEditorPage /> },
            { path: 'knowledgebase/:slug/edit', element: <ArticleEditorPage /> },
            { path: 'impersonation', element: <ImpersonationPage /> },
            { path: 'audit-logs', element: <AuditLogPage /> },
            { path: 'reports', element: <AdminReportsPage /> },
            { path: 'settings/integrations', element: <IntegrationsPage /> },
            { path: 'profile', element: <ProfilePage /> },
            { path: 'changelog', element: <ChangelogPage /> },
          ],
        },
        {
          // Portal shell: every /portal/* route shares PortalLayout + RequireAuth.
          // PortalLayout gates by CLIENT role; non-CLIENT users are redirected to /admin.
          // Plan 03-12 extends the children array with ticket history routes.
          path: '/portal',
          element: (
            <RequireAuth>
              <PortalLayout />
            </RequireAuth>
          ),
          children: [
            { index: true, element: <DashboardPage /> },
            { path: 'reports', element: <ReportsPage /> },
            { path: 'tickets', element: <MyTicketsPage /> },
            { path: 'tickets/new', element: <NewTicketPage /> },
            { path: 'tickets/:id', element: <PortalTicketDetailPage /> },
            { path: 'profile', element: <ProfilePage /> },
            { path: 'changelog', element: <ChangelogPage /> },
          ],
        },
        { path: '*', element: <div className="p-8">Page not found</div> },
      ],
    },
  ],
  { future: { v7_relativeSplatPath: true } },
);
